import { render, staticRenderFns } from "./additions.vue?vue&type=template&id=ed5ff5ae"
import script from "./additions.vue?vue&type=script&lang=js"
export * from "./additions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports